import React from 'react';
import FormInput from '../forms/FormInput';
import FormTextarea from '../forms/FormTextarea';
import Button from '../common/Button';
import Card from '../common/Card';
import { useForm } from '../../hooks/useForm';
import { validators } from '../../utils/validators';
import { theme } from '../../config/theme';

const StoreSettingsForm = ({ seller, onSubmit, loading }) => {
  const { values, errors, touched, handleChange, handleBlur, validate, setValues } = useForm(
    {
      store_name: seller?.store_name || '',
      store_description: seller?.store_description || '',
      business_email: seller?.business_email || '',
      business_phone: seller?.business_phone || '',
    },
    {
      store_name: (value) => validators.required(value, 'Store name'),
      business_email: (value) => value ? validators.email(value) : null,
      business_phone: (value) => value ? validators.phone(value, false) : null,
    }
  );

  React.useEffect(() => {
    if (seller) {
      setValues({
        store_name: seller.store_name || '',
        store_description: seller.store_description || '',
        business_email: seller.business_email || '',
        business_phone: seller.business_phone || '',
      });
    }
  }, [seller, setValues]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await onSubmit(values);
  };

  return (
    <Card padding="xl">
      <h2 style={{
        fontSize: theme.typography.fontSize.xl,
        fontWeight: theme.typography.fontWeight.semibold,
        marginBottom: theme.spacing.xl,
      }}>
        Store Settings
      </h2>

      <form onSubmit={handleSubmit}>
        <FormInput
          label="Store Name"
          name="store_name"
          value={values.store_name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.store_name}
          touched={touched.store_name}
          required
        />

        <FormTextarea
          label="Store Description"
          name="store_description"
          value={values.store_description}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Tell customers about your store..."
          rows={4}
        />

        <FormInput
          label="Business Email"
          name="business_email"
          type="email"
          value={values.business_email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.business_email}
          touched={touched.business_email}
        />

        <FormInput
          label="Business Phone"
          name="business_phone"
          type="tel"
          value={values.business_phone}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.business_phone}
          touched={touched.business_phone}
          placeholder="9876543210"
        />

        <Button type="submit" loading={loading} disabled={loading}>
          Save Store Settings
        </Button>
      </form>
    </Card>
  );
};

export default StoreSettingsForm;